// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s6-0";
export var fileList = "_s6-2";
export var removeFileButton = "_s6-1";